import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

export default FontAwesomeIcon
